import { defineAsyncComponent as t } from "vue";
import { c, b as s, d as a, e as g, v as d } from "./vuelidate-04GJpzoE.js";
import { s as w, u as y, a as C } from "./vuelidate-04GJpzoE.js";
let n;
function f(r) {
  if (r === !0 && (r = Object.keys(o)), r)
    for (const e of r)
      n.component(e, o[e]);
}
const v = {
  install(r, { formatter: e, translate: i, emitter: u, dev: p, register: m }) {
    n = r, c(e), s(i), a(u), p && g(), f(m), r.directive("vuelidate", d);
  }
}, o = {
  get "t-button"() {
    return t(() => import("./Button-CkAyItqk.js"));
  },
  get "t-button-icon"() {
    return t(() => import("./ButtonIcon-D4squ00_.js"));
  },
  get "t-combobox"() {
    return t(() => import("./Combobox-zKa2lri2.js"));
  },
  get "t-checkboxes"() {
    return t(() => import("./Checkboxes-CLFGhdUm.js"));
  },
  get "t-checkbox"() {
    return t(() => import("./Checkbox-B8p-bKhv.js"));
  },
  get "t-datetime"() {
    return t(() => import("./Datetime-BEqKzt4-.js"));
  },
  get "t-dropdown"() {
    return t(() => import("./Dropdown-Cy_Jl-0g.js"));
  },
  get "t-select"() {
    return t(() => import("./Select-Dmjule_0.js"));
  },
  get "t-switch"() {
    return t(() => import("./Switch-DBG6RDCK.js"));
  },
  get "t-radio"() {
    return t(() => import("./Radio-BohqdGUL.js"));
  },
  get "t-input"() {
    return t(() => import("./Input-KouLK2QK.js"));
  },
  get "t-input-number"() {
    return t(() => import("./InputNumber-CJ1ZLzd0.js"));
  },
  get "t-input-float"() {
    return t(() => import("./InputNumberFloat-CjOBLBJt.js"));
  },
  get "t-input-integer"() {
    return t(() => import("./InputNumberInteger-B5sjop0Q.js"));
  },
  get "t-input-duration"() {
    return t(() => import("./InputNumberDuration-CGgyR8Yg.js"));
  },
  get "t-input-percent"() {
    return t(() => import("./InputNumberPercent-DghiTrSE.js"));
  },
  get "t-input-icon"() {
    return t(() => import("./InputIcon-DYMgHv8r.js"));
  },
  get "t-input-email"() {
    return t(() => import("./InputEmail-CSNxzrre.js"));
  },
  get "t-input-password"() {
    return t(() => import("./InputPassword-CFcOJ5HW.js"));
  },
  get "t-input-search"() {
    return t(() => import("./InputSearch-DPusY0z8.js"));
  },
  get "t-input-tel"() {
    return t(() => import("./InputTel-Btcgb43z.js"));
  },
  get "t-input-url"() {
    return t(() => import("./InputUrl-Y_csVNO8.js"));
  },
  get "t-demo"() {
    return t(() => import("./Demo-hi4P2ly9.js"));
  },
  get "t-demo-section"() {
    return t(() => import("./DemoSection-CBEo8w66.js").then((r) => r.c));
  },
  get "t-error-tooltip"() {
    return t(() => import("./ErrorTooltip-gIdejoEn.js"));
  }
};
export {
  f as registerComponents,
  w as syncLazyResources,
  y as useValidation,
  C as validators,
  v as webComponents
};
//# sourceMappingURL=web-components.mjs.map
